/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'people': {
    width: 16,
    height: 16,
    viewBox: '0 0 16.12 15.3',
    data: '<g data-name="图层 2"><g data-name="图层 1" _fill="none" _stroke="#c4c4c4" stroke-linecap="round" stroke-linejoin="round"><circle pid="0" cx="5.62" cy="5.78" r="3.59"/><path pid="1" d="M5.62 14.8a10.69 10.69 0 004.58-1 .92.92 0 00.46-1.22 5.58 5.58 0 00-10.08 0A.92.92 0 001 13.77a10.69 10.69 0 004.62 1.03zM10.86 7.17a3.33 3.33 0 10-2.27-5.78M10.86 7.17a5.18 5.18 0 014.68 3 .85.85 0 01-.42 1.13 9.94 9.94 0 01-2.69.83"/></g></g>'
  }
})
